"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fp = require("fp-ts");
const monocle_ts_1 = require("monocle-ts");
const ActionTypes = require("../../actionTypes/ytj");
const status_1 = require("../../status");
const initialState = {
    status: status_1.RequestStatusFactory.fetch.standby(),
    error: null,
    company: null,
    shouldSearch: true,
    searchString: String(),
    searchResults: [],
    searchResultCount: 0
};
const statusLens = monocle_ts_1.Lens.fromProp('status');
const errorLens = monocle_ts_1.Lens.fromProp('error');
const companyLens = monocle_ts_1.Lens.fromProp('company');
const searchStringLens = monocle_ts_1.Lens.fromProp('searchString');
const searchResultsLens = monocle_ts_1.Lens.fromProp('searchResults');
const searchResultCountLens = monocle_ts_1.Lens.fromProp('searchResultCount');
const methods = {};
methods[ActionTypes.CLEAR] = () => (Object.assign({}, initialState));
methods[ActionTypes.GET_BY_BUSINESS_ID_REQUEST] = (state) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.busy()), errorLens.set(null), companyLens.set(null))(state);
methods[ActionTypes.GET_BY_BUSINESS_ID_SUCCESS] = (state, action) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.success()), companyLens.set(action.payload), searchStringLens.set(String()))(state);
methods[ActionTypes.GET_BY_BUSINESS_ID_FAILURE] = (state, action) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.failure()), errorLens.set(action.payload))(state);
methods[ActionTypes.SEARCH_REQUEST] = (state) => statusLens.set(status_1.RequestStatusFactory.fetch.busy())(state);
methods[ActionTypes.SEARCH_SUCCESS] = (state, action) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.success()), searchResultCountLens.set(action.payload.totalResults), searchResultsLens.set(action.payload.list), searchStringLens.set(String()))(state);
methods[ActionTypes.SEARCH_FAILURE] = (state, action) => fp.function.flow(statusLens.set(status_1.RequestStatusFactory.fetch.failure()), errorLens.set(action.payload))(state);
methods[ActionTypes.SET_SEARCH_STRING] = (state, action) => searchStringLens.set(action.payload)(state);
exports.default = (state = initialState, action) => {
    const fn = methods[action.type];
    return fn ? fn(state, action) : state;
};
//# sourceMappingURL=index.js.map